import React from "react";

import { Loader2 } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";

interface ActionButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  variant?: "default" | "outline" | "destructive";
  size?: "sm" | "default" | "lg";
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  icon?: React.ReactNode;
  loadingText?: string;
}

export const ActionButton = React.memo(function ActionButton({
  children,
  onClick,
  variant = "default",
  size = "default",
  disabled = false,
  loading = false,
  className,
  icon,
  loadingText,
}: ActionButtonProps) {
  const isDisabled = disabled || loading;
  const loadingLabel = loadingText || children;

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onClick}
      disabled={isDisabled}
    >
      {loading ? (
        <>
          <Loader2
            className={cn("w-4 h-4 animate-spin", loadingLabel && "mr-2")}
          />
          {loadingLabel}
        </>
      ) : (
        <>
          {icon && !children && icon}
          {icon && children && <span className="mr-2">{icon}</span>}
          {children}
        </>
      )}
    </Button>
  );
});
